import React from "react";
import _ from "lodash";
import axios from "axios";
import PropTypes from "prop-types";
import "../css/FormOffer.css";
import ChevronRight from "../svg/ICON_chevronRight_Dark.svg";
import {
  Form,
  Input,
  Label,
  Submit,
  ErrorAlert,
  ErrorHolder,
} from "elza-react";
import ReCAPTCHA from "react-google-recaptcha";

const fields = [
  { fieldname: "Lastname", name: "Nom", requis: true },
  { fieldname: "Firstname", name: "Prénom", requis: false },
  { fieldname: "Company", name: "Société", requis: false },
  { fieldname: "Email", name: "Email", requis: true },
];

/**
 * FormContact component
 */
class FormContact extends React.Component {
  static displayName = "FormContact";
  static propTypes = {
    className: PropTypes.string,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "FormOffer";

    this.state = {
      mounted: false,
      recaptchaValue: null,
    };
  }

  onRecaptchChange(value) {
    this.setState({ recaptchaValue: value });
  }

  /**
   * Wich fields we need to validate
   * @return {Array<Array<String|Function>>}
   */
  validations() {
    return [
      [
        // All fields that are required (presence validator.)
        ...fields
          .filter((field) => field.requis)
          .map((field) => "contact." + field.fieldname),
        (fieldValue, fieldName, formData) => {
          if (_.isEmpty(fieldValue)) formData.errors.add(fieldName, "blank");
        },
      ],
    ];
  }

  /**
   * @param  {FormData} formData
   */
  submit(formElement, formData) {
    if (formData.errors.any()) return; // Nothing to do here
    const data = new FormData(formElement);
    return axios.post("/contact-form/post_contact", data).then(
      (response) => {
        alert("Votre demande de contact a été envoyée", response.status);
        window.location.reload();
        formData.errors.clear();
        if (!_.isNil(this.recaptcha)) this.recaptcha.reset();
        return Promise.resolve();
      },
      (xhr) => {
        console.error("can not save response", xhr);
        if (_.has(xhr, "response.data.error")) {
          formData.errors.add(
            "contact.ServerError",
            _.get(xhr, "response.data.error")
          );
          setTimeout(() => {
            formData.errors.clear();
            if (!_.isNil(this.recaptcha)) this.recaptcha.reset();
          }, 5500);
        } else if (_.has(xhr, "response.data.errors")) {
          formData.errors.add(
            "contact.ServerError",
            _.join(
              _.get(xhr, "response.data.errors").map((error) => error.message),
              ". "
            )
          );
          setTimeout(() => {
            formData.errors.clear();
            if (!_.isNil(this.recaptcha)) this.recaptcha.reset();
          }, 5500);
        } else {
          console.error("Unknown error", xhr);
        }
        return false;
      }
    );
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <Form
          name="contact"
          validations={this.validations()}
          submit={this.submit}
          method="post"
          action="/new-offer/post_offer"
          encType="multipart/form-data"
          ref={(ref) => {
            if (!this.state.mounted) this.setState({ mounted: true });
          }}
        >
          <h2>Formulaire de contact</h2>
          <div className={`${this.className}__tip`}>
            <ErrorAlert htmlFor="contact">
              <div style={{ float: "right", color: "red" }}>
                Oups il y a un soucis
              </div>
            </ErrorAlert>
            <div style={{ marginBottom: "2rem" }}>* Champs requis</div>
          </div>

          <div className={`${this.className}__fields`}>
            {fields.map((field, index) => {
              return (
                <div key={index} className={`${this.className}__field`}>
                  <Label
                    className={`${this.className}__label`}
                    htmlFor={`contact.${field.fieldname}`}
                  >{`${field.name}${field.requis ? "*" : ""}`}</Label>
                  <Input
                    type="text"
                    className={`${this.className}__input`}
                    name={`contact.${field.fieldname}`}
                  />
                </div>
              );
            })}
            <div className={`${this.className}__field no-vertical-align`}>
              <Label
                htmlFor="contact.Message"
                className={`${this.className}__label`}
              >
                Message*
              </Label>
              <textarea
                name="contact.Message"
                className={`${this.className}__textarea`}
              />
            </div>
            <div className={`${this.className}__footer`}>
              <div className={`${this.className}__recaptcha`}>
                <ReCAPTCHA
                  ref={(recaptcha) => (this.recaptcha = recaptcha)}
                  sitekey="6LfymSQUAAAAAMLC2Q4jDmAb45PePtZylylihGyQ"
                  size="normal"
                  onChange={this.onRecaptchChange.bind}
                />
              </div>
            </div>
            <ErrorHolder htmlFor="contact.ServerError" />
            <ErrorHolder htmlFor="contact.recaptcha" />

            <Submit htmlFor="contact" className={`${this.className}__submit`}>
              Envoyer message
              <img src={ChevronRight} className="icon" alt=">" />
            </Submit>
          </div>
        </Form>
      </div>
    );
  }
}

export default FormContact;



// WEBPACK FOOTER //
// ./src/components/FormContact.js